export type ContentfulTokenKind = 'access' | 'preview' | 'cma' | 'webhook';

export interface ContentfulConfigErrorOptions {
  token: ContentfulTokenKind;
  context?: string;
}

export class ContentfulConfigError extends Error {
  readonly token: ContentfulTokenKind;

  readonly context?: string;

  constructor({ token, context }: ContentfulConfigErrorOptions) {
    const baseMessage = `Contentful ${token} token is not configured`;
    super(context ? `${baseMessage} (${context})` : baseMessage);
    this.name = 'ContentfulConfigError';
    this.token = token;
    this.context = context;
  }
}
